/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentoCittadinoSpuntaDTO } from './documento-cittadino-spunta-dto';


export interface DocumentoCittadinoDTO { 
    documento_id?: string;
    versione?: number;
    pubblicato_at?: string;
    titolo?: string;
    testo_html?: string;
    aggiornamento?: boolean;
    spunte?: Array<DocumentoCittadinoSpuntaDTO>;
}

